<iframe
[src]="fileSrc"
frameborder="0"

></iframe>